type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  fillColor?: string;
};

const InstagramCommentIcon = (props: Props) => {
  const {
    width = '24',
    height = '24',
    viewBox = '0 0 24 24',
    fillColor = 'currentColor',
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
    >
      <path
        d="M20.656 17.008a9.993 9.993 0 1 0-3.59 3.615L22 22Z"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default InstagramCommentIcon;
